import React from 'react';
import { StarIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { OFFER_ANCHOR, testimonials } from '../data/content';
export function Testimonials() {
  return <section aria-labelledby="testimonios" className="bg-brand" data-id="element-170" data-mp="3fycoti6qzx8o">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-171" data-mp="3b146nhllnt7f">
        <h2 id="testimonios" className="font-display text-[1.5rem] font-extrabold leading-[1.1] tracking-tight text-white sm:text-4xl" data-id="element-172" data-mp="3ayqb77n0cezc">
          Lo que dicen{' '}
          <span className="text-highlight" data-id="element-173" data-mp="32291m8uakp5p">quienes ya empezaron</span>
        </h2>
        <p className="mx-auto mt-1 max-w-xl text-sm leading-snug text-white/90" data-id="element-174" data-mp="2x11ri34ofdvv">
          De no saber por dónde comenzar a comprender cómo funciona la
          contabilidad.
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-175" data-mp="v8wtqb0hxmd8">
          {testimonials.map((t, i) => <Reveal key={t.author} as="li" delay={i * 0.03} className={`flex h-full flex-col rounded-xl border-2 border-highlight bg-white p-2.5 text-left text-ink ${i === testimonials.length - 1 ? 'sm:col-span-2' : ''}`} data-id="element-176" data-mp="qav93lnf9ezn" data-mpi={i}>
              <div className="flex items-center justify-between gap-2" data-id="element-177" data-mp="7a4xozqmtrny">
                <span className="font-sub text-xs font-semibold text-cta" data-id="element-178" data-mp="c7dg91fozxpq">
                  TESTIMONIO {i + 1}
                </span>
                <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-179" data-mp="14vj3buu7xysq">
                  {Array.from({
                length: 5
              }).map((_, j) => <StarIcon key={j} size={13} className="fill-highlight text-highlight" data-id="element-180" data-mp="q5lb93t64oy9" data-mpi={j} />)}
                </div>
              </div>
              <blockquote className="mt-1 text-xs italic leading-snug sm:text-sm" data-id="element-181" data-mp="1it7bq373ndgw">
                “{t.quote}”
              </blockquote>
              <div className="mt-auto pt-1.5" data-id="element-182" data-mp="1xiiswxhyhmj8">
                <p className="font-sub text-sm font-semibold text-brand" data-id="element-183" data-mp="1xh7pwzwc4it6">
                  {t.author}
                </p>
                <p className="text-xs leading-snug text-ink/80" data-id="element-184" data-mp="1sh3918rilm2f">
                  {t.role} · {t.location}
                </p>
              </div>
            </Reveal>)}
        </ul>

        <CtaButton href={OFFER_ANCHOR} className="mt-4" data-id="element-185" data-mp="1jkc221bfcmt2">
          🚀 Sí, quiero comenzar ahora
        </CtaButton>
        <p className="mt-2.5 text-xs font-semibold text-white/80" data-id="element-186" data-mp="19sepor8ojosr">
          Acceso Inmediato • Garantía de 7 Días
        </p>
      </div>
    </section>;
}